import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

const NotesToggle = ({
  visible,
  onToggle,
  l, // translations
  toggle,
  active,
  aiVisible
}) => {
  const isActive = visible && !aiVisible;

  return (
    <Button
      className="right-section-btn"
      toggle
      active={isActive}
      style={{
        marginLeft: '8px',
        padding: '0.7em',
        transition: 'background-color 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      size='mini'
      onClick={onToggle}
      title={l?.toggle_notes || 'Toggle Notes'}
    >
      <Icon
        name={isActive ? 'file text' : 'file text outline'}
        size='large'
        style={{
          margin: 0
        }}
      />
    </Button>
  );
};

export default React.memo(NotesToggle);
